import {combineReducers} from "redux";
// Front
import Layout from "./layout/reducer";
import Variables from "./auth/variables/reducer";
import Tokens from "./auth/tokens/reducer";
// Authentication
import User from "./auth/user/reducer";
import Login from "./auth/login/reducer";
import Register from "./auth/register/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import Mfa from "./auth/mfa/reducer";
// Cart
import Cart from "./cart/reducer";
import Info from "./info/reducer";

const rootReducer = combineReducers({
    // public
    Layout,
    User,
    Login,
    Register,
    ForgetPassword,
    Mfa,
    Cart,
    Info,
    Variables,
    Tokens
});

export default rootReducer;
